import { Navigate, useLocation } from "react-router-dom";

function detectBrowserLanguage(): "de" | "en" {
  const browserLang = navigator.language || (navigator as any).userLanguage || "de";
  return browserLang.startsWith("de") ? "de" : "en";
}

/**
 * Root redirect: detects browser language and redirects to /de or /en
 */
export default function LanguageRedirect() {
  const location = useLocation();
  const lang = detectBrowserLanguage();
  const target = `/${lang}${location.search}${location.hash}`;
  return <Navigate to={target} replace />;
}
